import { MenuItem } from '@core/models';
import {
	CartItemRemovalContext,
	CartStockRefreshContext,
	CartStockRefreshEffectInput,
} from '../interfaces';

export function prepareCartStockRefresh(
	input: CartStockRefreshEffectInput
): CartStockRefreshContext {
	return {
		cartItems: input?.cartItems ?? [],
		localChannelId: input.localChannelId,
		menuId: input.action.menuId ?? null,
		articleIds: [...new Set((input.cartItems ?? []).map(item => item.idArticulo))],
	};
}

export function mergeCartStockUpdates(
	cartItems: MenuItem[] | null,
	updatedMenuItems: MenuItem[]
): MenuItem[] {
	return (cartItems ?? []).map(cartItem => {
		const matchingStockItem = updatedMenuItems.find(
			stockItem => stockItem.idArticulo === cartItem.idArticulo
		);

		return {
			...cartItem,
			isUnavailable: !matchingStockItem,
			stock: matchingStockItem ? matchingStockItem.stock : cartItem.stock,
		};
	});
}

export function prepareCartItemRemoval(
	idCartItem: string,
	cartItems: MenuItem[] | null
): CartItemRemovalContext {
	return {
		cartItems,
		idCartItem,
		shouldRemove: !!idCartItem,
		updatedCartItems: idCartItem
			? (cartItems ?? []).filter(cartItem => cartItem.idCartItem !== idCartItem)
			: (cartItems ?? []),
	};
}

export function clearCartForStore(
	cartItems: MenuItem[] | null,
	storeSlug: string
): MenuItem[] {

	return (cartItems ?? []).filter(cartItem => cartItem.storeSlug !== storeSlug);
}

export function filterCartByStore(
	cartItems: MenuItem[] | null,
	storeSlug: string
): MenuItem[] {

	return (cartItems ?? []).filter(cartItem => cartItem.storeSlug === storeSlug);
}
